type Falsey = null | undefined | false | '' | 0

export const compact = <T>(array: (T | Falsey)[] | null | undefined) =>
    array?.filter(
        (item) => item !== null && item !== undefined && item !== false && item !== '' && item !== 0
    ) as T[]
